import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const Aide = () => {
    let location = useLocation();

    return (
        <div>
            <Helmet>
                <title>Aide</title>
                <meta name='description' content='Restaurant aide.' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <h1>Restaurant aide</h1>
        </div>
    )
}

export default Aide